module.exports = __webpack_public_path__ + "static/media/csa-logo.19397395.png";